import React from 'react'
import { Link, Meta, Title } from 'react-head'
import { GoogleFonts } from 'src/components/meta/google-fonts'
import { LazyTrackingHead } from 'src/components/meta/tracking/lazyTracking'
import { usePageContext } from 'src/contexts/page.context'
import { useSecurityContext } from 'src/contexts/security.context'
import {
  makeGoogleTicker,
  makeSecurityDescription,
  makeSecurityLink,
} from 'src/shared/utils'

import { GoogleTagManager } from './tracking/googleTagManager'

export const Head = () => {
  const { reportName, siteUrl } = usePageContext()
  const { security } = useSecurityContext()

  const { name, ticker } = security

  const title = `${name} Share Price - ${ticker} ${reportName} | Stockopedia`
  const description = makeSecurityDescription(security)

  return (
    <>
      <GoogleFonts />
      <script
        src="https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js"
        async
      />

      <Title>{title}</Title>
      <Meta name="description" content={description} />
      <meta
        name="keywords"
        content={`${security.name} share price, ${makeGoogleTicker(
          security,
        )} share price`}
      />

      <Link
        rel="icon"
        href="https://www.stockopedia.com/images/favicon.ico"
        type="image/x-icon"
      />
      <Link
        rel="shortcut icon"
        href="https://www.stockopedia.com/images/favicon.ico"
        type="image/x-icon"
      />

      <Link rel="canonical" href={`${siteUrl}${makeSecurityLink(security)}/`} />
      <Meta httpEquiv="Content-type" content="text/html; charset=utf-8" />

      <Meta property="og:title" content={title} />
      <Meta property="og:description" content={description} />
      <Meta property="og:type" content="website" />
      <Meta property="og:site_name" content="Stockopedia" />
      <Meta property="fb:app_id" content="213300455850" />
      <Meta property="og:image" content={security.image} />
      <Meta property="og:url" content={makeSecurityLink(security)} />

      <Meta
        name="google-site-verification"
        content="zOJDcY3lJ5sp49sXclOc4kDn0MDuvk0CFiuJNCnUEhA"
      />

      <Meta name="y_key" content="7dd41029ec5bb298" />
      <Meta name="msvalidate.01" content="091CAD9360D2CA55173FBC556404FE39" />

      <Link rel="dns-prefetch" href="https://images.stockopedia.com" />
      <Link rel="dns-prefetch" href="https://www.facebook.com" />
      <Link rel="dns-prefetch" href="https://connect.facebook.net" />
      <Link rel="dns-prefetch" href="https://a.optmnstr.com" />
      <Link rel="dns-prefetch" href="https://www.google.co.uk" />
      <Link rel="dns-prefetch" href="https://www.googleadservices.com" />
      <Link rel="dns-prefetch" href="https://www.google-analytics.com" />
      <Link rel="dns-prefetch" href="https://www.googletagmanager.com" />
      <Link rel="dns-prefetch" href="https://vc.hotjar.io" />

      <GoogleTagManager />
      <LazyTrackingHead />
    </>
  )
}
